/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br>
  <div>
  <div class="formPosition">
      <v-card style="margin:auto;" width="1200" >
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
       <v-card-title>
        <span>Listagem simples de clientes</span>
         <v-spacer></v-spacer>
         <v-row style="border:1px solid #ccc;width:420px;background-color:#006699;">
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
      </v-card-title>
        <template>
          <v-data-table :headers="headers" :items="produtos">
          </v-data-table>
        </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    tab: null,
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome do Cliente',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Nif', value: 'numero_documento' },
      { text: 'Telefone', value: 'telefone' },
      { text: 'Email', value: 'email' },
      { text: 'Morada', value: 'morada' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      email: '',
      nome: '',
      numero_documento: '111111',
      telefone: '(941)926369'
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },

  methods: {
    async initialize () {
      try {
        this.progresso = true
        this.produtos = await axios
          .post('/clienteFindAlll', this.$store.state.camposListagemCliente)
          .then(res => res.data)
        if (this.produtos.length) { this.progresso = false }
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          // eslint-disable-next-line no-mixed-operators
          value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log(this.$store.state.actividades)
      } catch (error) {

      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        console.log(this.cursos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount

      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
        this.isLoading = false
        console.log(this.turmasFiltered)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },
    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    }

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}

</style>
